import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentResult({ cancel }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(cancel ? "cancelled" : "checking");
  const [kind, setKind] = useState(null);
  const [runId, setRunId] = useState(null);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (cancel || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setKind(data.type);
        setRunId(data.run_id || null);
        if (data.payment_status === "paid") return setStatus("success");
        if (data.payment_status === "expired" || tries > 10) return setStatus("failed");
      } catch { if (tries > 10) return setStatus("failed"); }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, cancel]);

  return (
    <div className="min-h-[70vh] grid place-items-center px-4">
      <div className="text-center max-w-md">
        {status === "checking" && (<><Loader2 className="h-12 w-12 animate-spin text-sam-crimson mx-auto" /><h1 className="mt-6 font-display text-2xl font-bold text-sam-navy">Confirming your payment…</h1><p className="text-sam-slate mt-2">One moment while we lock in your purchase.</p></>)}
        {status === "success" && (<><CheckCircle2 className="h-16 w-16 text-sam-green mx-auto" /><h1 className="mt-6 font-display text-3xl font-extrabold text-sam-navy">You're all set!</h1><p className="text-sam-slate mt-2">{kind === "postcard_slot" ? "Your postcard slot is reserved and your ad is live on the mailer." : kind === "mailer" ? "Your postcard mailer campaign is booked — your online listing is included free while it runs, and you're now in our CRM." : "Your listing is now upgraded — add products, services and deals from your dashboard."}</p><div className="mt-6 flex gap-2 justify-center flex-wrap">{kind === "postcard_slot" && runId && <Button className="bg-sam-crimson hover:bg-sam-crimson/90" onClick={() => navigate(`/postcards/${runId}`)} data-testid="view-spot-btn">See your spot on the postcard</Button>}<Button className="bg-sam-navy hover:bg-sam-navy2" onClick={() => navigate("/dashboard")}>Go to Dashboard</Button></div></>)}
        {(status === "failed" || status === "cancelled") && (<><XCircle className="h-16 w-16 text-sam-crimson mx-auto" /><h1 className="mt-6 font-display text-2xl font-bold text-sam-navy">{status === "cancelled" ? "Checkout cancelled" : "Payment not completed"}</h1><p className="text-sam-slate mt-2">No charge was made. You can try again anytime.</p><div className="mt-6 flex gap-2 justify-center"><Button variant="outline" asChild><Link to="/postcards">Postcard routes</Link></Button><Button className="bg-sam-navy" asChild><Link to="/dashboard">Dashboard</Link></Button></div></>)}
      </div>
    </div>
  );
}
